import { Box, styled } from '@mui/material'
import { Button } from '../../../components/Button'
import { colors } from '../../../themes/colors'
import { shouldForwardProp } from '../../../util/helpers'
import { BOTTOM_NAVIGATION_HEIGHT } from '../../../util/consts'
import TextField from '../../../components/TextField'

export const Container = styled('div', {
  shouldForwardProp: (prop) =>
    shouldForwardProp<{ buttonBoxHeight: number }>(['buttonBoxHeight'], prop),
})<{ buttonBoxHeight: number }>(({ theme, buttonBoxHeight }) => ({
  backgroundColor: theme.colors.primary50,
  width: '100%',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
  height: 'fit-content',
  maxWidth: '335px',
  minWidth: '335px',
  [theme.breakpoints.down('lg')]: {
    maxWidth: 'unset',
    minWidth: 'unset',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0',
    backgroundColor: 'transparent',
    marginBottom: `${buttonBoxHeight + 32}px`,
  },
}))

export const GapContainer = styled('div')<{ gap?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => gap ?? 0};
`

export const ButtonBox = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  [theme.breakpoints.down('sm')]: {
    position: 'fixed',
    bottom: BOTTOM_NAVIGATION_HEIGHT,
    left: 0,
    background: colors.primary25,
    padding: '16px',
    borderTop: `1px solid ${colors.primary200}`,
  },
}))

export const InlineFlex = styled('div')`
  display: inline-flex;
  justify-content: space-between;
  gap: 32px;
`
export const ReferenceNoteWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
})

export const Textarea = styled(TextField)`
  width: 100%;
`

export const SubmitButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    width: '100%',
  },
}))
